import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector } from 'hooks/useSelector';
import { ActivityIndicator } from 'components/BlockingLoader/ActivityIndicator';
import { theme } from 'lib/theme';
import { selectAsesListLoadStatus } from 'store/ases/selectors';

export const AssessmentListLoader = () => {
  const loadStatus = useSelector(selectAsesListLoadStatus);
  if (loadStatus?.status === 'loading') {
    return (
      <View
        style={[
          StyleSheet.absoluteFill,
          {
            zIndex: 2,
            alignItems: 'center',
            backgroundColor: `${theme.colors.background50}`,
            justifyContent: 'center',
          },
        ]}
      >
        <ActivityIndicator size={60} />
      </View>
    );
  }
  return null;
};
